import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.orgStructureSpaceWfuhs',
    'package:data.higherEd.research.sponsors',
    'resource:data.dimensions.awards',
    'resource:data.dimensions.awards.entities.award',
    'resource:data.dimensions.awards.entities.award.attributes.submissionDate',
    'resource:data.dimensions.awards.entities.award.attributes.sponsor',
    'resource:data.dimensions.awards.entities.award.attributes.space',
    'resource:data.dimensions.awards.entities.award.attributes.organization',
    'resource:data.dimensions.awards.entities.award.attributes.fan',
    'resource:data.dimensions.awards.entities.award.attributes.fain',
    'resource:data.dimensions.awards.entities.award.attributes.budget',
    'resource:data.dimensions.awards.entities.award.attributes.awardDate',
    'resource:data.dimensions.awards.entities.award.attributes.assistanceListing',
    'resource:data.dimensions.awards.entities.award.attributes.researchTypeWfuhs',
    'resource:data.dimensions.awardPis',
    'resource:data.dimensions.awardPis.entities.entry',
    'resource:data.dimensions.awardPis.entities.entry.attributes.pi',
    'resource:data.dimensions.awardPis.entities.entry.attributes.award',
    'resource:data.dimensions.assistanceListings',
    'resource:data.dimensions.assistanceListings.entities.listing',
    'resource:data.enums.researchTypeWfuhs',
    'resource:data.enums.researchTypeWfuhs.entries.appliedResearch',
    'resource:data.enums.researchTypeWfuhs.entries.basicResearch',
    'resource:data.enums.researchTypeWfuhs.entries.clinicalResearch',
    'resource:data.enums.researchTypeWfuhs.entries.clinicalTrials',
    'resource:data.enums.researchTypeWfuhs.entries.demonstrationAndServices',
    'resource:data.enums.researchTypeWfuhs.entries.equipment',
    'resource:data.enums.researchTypeWfuhs.entries.fellowship',
    'resource:data.enums.researchTypeWfuhs.entries.institutionalSupport',
    'resource:data.enums.researchTypeWfuhs.entries.instructionalActivities',
    'resource:data.enums.researchTypeWfuhs.entries.operations',
    'resource:data.enums.researchTypeWfuhs.entries.program',
    'resource:data.enums.researchTypeWfuhs.entries.publicService',
    'resource:data.enums.researchTypeWfuhs.entries.salariesAndWages',
    'resource:data.enums.researchTypeWfuhs.entries.trainingActivities',
  ],
  description: 'TODO',
  name: 'Research Data - Awards',
} as const satisfies core.quiver.Package
